<mat-card appearance="outlined" class="mat-elevation-z4">
    <mat-card-content>
        @if (!isLoading()) {
            @let basicData = currentData();
            <form [formGroup]="formGroup" class="container ml-0 mb-5 d-flex flex-column">
                <!-- Netvote settings -->
                <div>
                    <h2>{{ 'GeneralSettings.NetvoteSettings.Title' | translate }}</h2>
                    @if (basicData) {
                        <div>{{ basicData.netvoteCredentialsInfo }}</div>
                    }
                    <p class="mb-1">{{ 'GeneralSettings.NetvoteSettings.Description' | translate }}</p>
                </div>
                <mat-checkbox [formControl]="formGroup.controls.netvoteShowYesInstruction">
                    "{{ 'GeneralSettings.NetvoteSettings.NetvoteShowYes' | translate }}"
                </mat-checkbox>
                <mat-checkbox [formControl]="formGroup.controls.netvoteShowNoInstruction">
                    "{{ 'GeneralSettings.NetvoteSettings.NetvoteShowNo' | translate }}"
                </mat-checkbox>
                <mat-checkbox [formControl]="formGroup.controls.netvoteShowAbstentionInstruction">
                    "{{ 'GeneralSettings.NetvoteSettings.NetvoteShowAbstention' | translate }}"
                </mat-checkbox>
                <mat-checkbox [formControl]="formGroup.controls.netvoteShowBodAgreeInstruction">
                    "{{ 'GeneralSettings.NetvoteSettings.NetvoteShowBoDAgree' | translate }}"
                </mat-checkbox>
                <mat-checkbox [formControl]="formGroup.controls.netvoteShowBodDisagreeInstruction">
                    "{{ 'GeneralSettings.NetvoteSettings.NetvoteShowBoDDisagree' | translate }}"
                </mat-checkbox>
                <mat-checkbox [formControl]="formGroup.controls.netvoteUseWordingForCooperatives">
                    {{ 'GeneralSettings.NetvoteSettings.NetvoteUseWordingForCooperatives' | translate }}
                </mat-checkbox>
                <mat-checkbox [formControl]="formGroup.controls.netvote2FADisabled">
                    {{ 'GeneralSettings.NetvoteSettings.Netvote2FADisabled' | translate }}
                </mat-checkbox>
                <p>{{ 'GeneralSettings.NetvoteSettings.Netvote2FADisabledNote' | translate }}</p>
                <mat-checkbox [formControl]="formGroup.controls.mobileConfirmationDisabled">
                    {{ 'GeneralSettings.NetvoteSettings.MobileConfirmationDisabled' | translate }}
                </mat-checkbox>
                <mat-checkbox [formControl]="formGroup.controls.encourageElectronicDeliveryMethod">
                    {{ 'GeneralSettings.NetvoteSettings.EncourageElectronicDeliveryMethod' | translate }}
                </mat-checkbox>

                <sl-input
                    [control]="formGroup.controls.netvoteCredentialPrefix"
                    [minLength]="3"
                    [maxLength]="3"
                    [inputSize]="3"
                    [customStyle]="{ 'text-transform': 'uppercase' }"
                    placeholderKey="GeneralSettings.NetvoteSettings.NetvoteCredentialPrefix" />
                <mat-form-field>
                    <mat-label>{{ 'GeneralSettings.NetvoteSettings.NetvoteInstructionText' | translate }}</mat-label>
                    <textarea matInput [formControl]="formGroup.controls.netvoteInstructionText"></textarea>
                    <mat-error>
                        <sl-form-field-error-control [control]="formGroup.controls.netvoteInstructionText" />
                    </mat-error>
                </mat-form-field>

                <!-- Theme settings -->
                <h2 class="mt-3 mb-1">{{ 'GeneralSettings.ThemeSettings.Title' | translate }}</h2>
                @if (formGroup.value.netvoteBackgroundUrl) {
                    <div class="mb-3">
                        <img class="background-preview" [src]="formGroup.value.netvoteBackgroundUrl" />
                    </div>
                }
                <sl-input
                    type="text"
                    placeholderKey="GeneralSettings.ThemeSettings.NetvoteBackgroundUrl"
                    [control]="formGroup.controls.netvoteBackgroundUrl" />
                <sl-input
                    type="color"
                    placeholderKey="GeneralSettings.ThemeSettings.NetvotePrimaryColor"
                    [control]="formGroup.controls.netvotePrimaryColor" />
                <mat-checkbox [formControl]="formGroup.controls.languageDe">
                    {{ 'GeneralSettings.ThemeSettings.LanguageDe' | translate }}
                </mat-checkbox>
                <mat-checkbox [formControl]="formGroup.controls.languageEn">
                    {{ 'GeneralSettings.ThemeSettings.LanguageEn' | translate }}
                </mat-checkbox>
                <mat-checkbox [formControl]="formGroup.controls.languageFr">
                    {{ 'GeneralSettings.ThemeSettings.LanguageFr' | translate }}
                </mat-checkbox>
                <mat-checkbox [formControl]="formGroup.controls.languageIt">
                    {{ 'GeneralSettings.ThemeSettings.LanguageIt' | translate }}
                </mat-checkbox>

                <!-- General meeting settings -->
                <h2 class="mt-3 mb-1">{{ 'GeneralSettings.GeneralMeetingSettings.Title' | translate }}</h2>
                @if (!!basicData?.hasActiveMeeting) {
                    <mat-checkbox [formControl]="formGroup.controls.allowWebRegistrationSelf">
                        {{ 'GeneralSettings.NetvoteSettings.AllowWebRegistrationSelf' | translate }}
                    </mat-checkbox>
                    <mat-checkbox [formControl]="formGroup.controls.allowWebRegistrationIndependentProxy">
                        {{ 'GeneralSettings.NetvoteSettings.AllowWebRegistrationIndependentProxy' | translate }}
                    </mat-checkbox>
                    <mat-checkbox [formControl]="formGroup.controls.allowWebAttendance">
                        {{ 'GeneralSettings.NetvoteSettings.AllowWebAttendance' | translate }}
                    </mat-checkbox>
                    <mat-checkbox [formControl]="formGroup.controls.allowElectronicAdmissionCard">
                        {{ 'GeneralSettings.NetvoteSettings.AllowElectronicAdmissionCard' | translate }}
                    </mat-checkbox>
                }
                <button mat-stroked-button type="button" (click)="exportGm()" class="w-100 mt-2" [disabled]="!basicData?.hasActiveMeeting">
                    {{ 'GeneralMeeting.Export' | translate }}
                </button>
                <button mat-stroked-button type="button" (click)="importGm()" class="w-100 mt-2">
                    {{ 'GeneralMeeting.Import' | translate }}
                </button>
            </form>
        } @else {
            <div class="w-100 d-flex justify-content-center">
                <mat-spinner [diameter]="48" />
            </div>
        }
    </mat-card-content>
</mat-card>
